import { EditOutgoing, EditProforma, EditRFI } from "./modules";

export { Create } from "./modules";

export const Edit = {
  RequestForInvoice: EditRFI,
  Outgoing: EditOutgoing,
  Proforma: EditProforma,
};
